export default "__VITE_ASSET__7b28ecaa__"